import { uselocalStorageGetterSetter } from '@/composables/uselocalStorageGetterSetter';

export function useTooltipVisibility(newFeatureSlug) {
  const { getNewFeaturesObject, setNewFeaturesObject } =
    uselocalStorageGetterSetter();

  let newFeaturesObj = getNewFeaturesObject();

  const setFeatureIsNewToFalse = () => {
    const localStorageObj = { [newFeatureSlug]: false };
    setNewFeaturesObject(localStorageObj);
  };

  const setFeatureToNew = () => {
    const localStorageObj = { [newFeatureSlug]: true };
    setNewFeaturesObject(localStorageObj);
  };

  if (newFeaturesObj[newFeatureSlug] === undefined) {
    setFeatureToNew();
    newFeaturesObj = getNewFeaturesObject();
  }

  const isFeatureNew = !!newFeaturesObj[newFeatureSlug];

  return {
    isFeatureNew,
    setFeatureIsNewToFalse,
    setFeatureToNew,
  };
}
